import { render, staticRenderFns } from "./TierSelectionModal.vue?vue&type=template&id=13fe2848&scoped=true"
import script from "./TierSelectionModal.vue?vue&type=script&lang=js"
export * from "./TierSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./TierSelectionModal.vue?vue&type=style&index=0&id=13fe2848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe2848",
  null
  
)

export default component.exports